import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import React from 'react';
import { FaTimes } from 'react-icons/fa';

export default function Modal({ isOpen, onClose, children, title, isCloseClick = true, overflow = false, alignTop = false, className = "w-8/12", headerClass = "" }) {
    if (isOpen) {
        return (
            <Dialog open={isOpen} onClose={isCloseClick ? onClose : () => {}} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className={"fixed inset-0 p-1 w-full overflow-y-auto justify-self-center report-center"} >
                    <div className={`flex h-full items-end justify-center text-center sm:p-0 ${alignTop ? "sm:items-start" : "sm:items-center"}`}>
                        <DialogPanel transition
                                     className={[`relative transform ${overflow ? 'overflow-visible' : 'overflow-hidden'} rounded-xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`, className].join(" ")} >

                            <div className="bg-white border-b border-gray-300 rounded-xl">
                                <DialogTitle as="h3" className={["font-semibold text-gray-500 leading-6 border-b border-gray-300 px-3 py-3 flex justify-between !my-0", headerClass].join(" ")}>
                                    {title}
                                    <span onClick={onClose} className="cursor-pointer content-center">
                                        <FaTimes />
                                    </span>
                                </DialogTitle>
                                {children}
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        )
    }

    return null
}